import { apiPost, apiGet } from '@/api/api.ts';

export interface IReqSignup {
    email: string;
    password: string;
    name: string;
    contact: string;
    address: string;
    latitude: string;
    longitude: string;
    centerName: string;
    centerContact: string;
    gender: number;
    birthDate: string;
    inspectorMemo: string;
    privacyAgreed?: boolean;
}

export const apiSignup = async (params: IReqSignup) => {
    return await apiPost(`/app/auth/register`, params);
};

/**
 * 이메일 중복 확인 API
 * @param email 확인할 이메일 주소
 * @returns API 응답 (exists: 이메일 존재 여부)
 */
export const apiCheckEmail = async (email: string) => {
    return await apiGet(`/app/auth/check-email?email=${email}`);
};
